import React, { useEffect, useState } from 'react'
import Container from '../../../ui/comp/Container'
import Switch from 'react-switch'
import Input from '../../../ui/forms/Input'
import Button from '../../../ui/comp/Button'
import { useMutation, useQuery } from '@tanstack/react-query'
import { Axios } from '../../../utils/Axios'
import toast from 'react-hot-toast'

function HotUpdate() {

    const [formData, setFormData] = useState({
        message: "",
        enabled: false
    })

    const { data } = useQuery({
        queryKey: ['hot-update'],
        queryFn: async () => {
            const res = await Axios.get('/store/hot-update')
            return res.data
        }
    })

    useEffect(() => { setFormData(data || { message: "", enabled: false }) }, [data])

    const handleChangeSwitch = () => {
        setFormData({ ...formData, enabled: !formData.enabled })
    }

    const { mutate, isPending } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/store/hot-update', formData)
        },
        onError: (error) => {
            toast.error(error?.response?.data || error.message)
        },
        onSuccess: () => {
            toast.success("Successfully")
        }
    })

    const sendData = () => {
        mutate(formData)
    }

    return (
        <div className='w-full relative'>
            <Container title={"Hot Update"}>
                <div className="mt-7 space-y-4">
                    {/* Enabled */}
                    <div className="flex items-center gap-3">
                        <div className="w-32"> <p>Enabled</p></div>
                        <div className="w-full">
                            <Switch
                                checked={formData?.enabled}
                                onChange={handleChangeSwitch}
                                checkedIcon={false}
                                uncheckedIcon={false}
                                onColor='#180787'
                                height={20}
                                handleDiameter={15}
                                width={38}
                            />
                        </div>
                    </div>

                    {/* Message */}
                    <div className="flex items-center gap-3">
                        <div className="w-32"> <p>Message</p></div>
                        <div className="w-full">
                            <Input value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} />
                        </div>
                    </div>


                </div>

                <div className="mt-6">
                    <Button onClick={sendData} loading={isPending}>Submit</Button>
                </div>
            </Container>
        </div>
    )
}

export default HotUpdate